var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFireflinkMiniLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.045,
    height: 17.625,
    viewBox: "0 0 16.045 17.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17887",
    "data-name": "Group 17887",
    transform: "translate(-662.977 -574)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17885",
    "data-name": "Group 17885",
    transform: "translate(-136 245.313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17884",
    "data-name": "Group 17884",
    transform: "translate(-82 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    d: "M-1144.216-446.779c-.226.135-.406.226-.587.316-.677.361-1.309.677-1.986,1.038a.273.273,0,0,0-.135.271v13.679c0,.181-.045.316-.226.361a2.262,2.262,0,0,1-2.077-.181,2.091,2.091,0,0,1-.858-1.354,12.141,12.141,0,0,1-.135-2.212c-.045-3.612-.09-7.268-.09-10.88a3.457,3.457,0,0,1,.316-1.67,2.021,2.021,0,0,1,2.393-1.083,6.641,6.641,0,0,1,1.806.858c.5.271.993.542,1.444.813C-1144.306-446.87-1144.261-446.825-1144.216-446.779Z",
    transform: "translate(2031.297 778.76)",
    fill: "#434db8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    d: "M-1136.6-428.762v-3.928a.322.322,0,0,1,.135-.271c1.535-.858,3.07-1.716,4.56-2.573.406-.226.813-.451,1.264-.722a7.3,7.3,0,0,0-.813-.451c-.677-.406-1.354-.767-2.031-1.174a.2.2,0,0,0-.226,0c-.858.542-1.67,1.038-2.528,1.58-.045,0-.045.045-.09.045v-2.889a.41.41,0,0,1,.135-.316c.768-.542,1.535-1.038,2.257-1.58a.288.288,0,0,1,.271,0c1.038.587,2.122,1.219,3.16,1.806.722.406,1.445.813,2.212,1.219a3.2,3.2,0,0,1,1.309,1.264,1.908,1.908,0,0,1-.271,2.212,4.391,4.391,0,0,1-1.264.993c-1.038.587-2.031,1.219-3.07,1.806-1.309.767-2.573,1.49-3.882,2.257C-1135.878-429.213-1136.239-428.988-1136.6-428.762Z",
    transform: "translate(2023.771 774.647)",
    fill: "#434db8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireflinkMiniLogo);
export default __webpack_public_path__ + "static/media/fireflink-mini-logo.334d0cc6ea4ea74f8026bf72b90c2b21.svg";
export { ForwardRef as ReactComponent };